import { Container, Graphics, PointData, Text } from "pixi.js";

export class KeyIcon {
	public readonly container: Container = new Container();
	public readonly graphics: Graphics;
	public readonly keyText: Text;
	readonly description: Text;
	public elapsed: number = 0;

	public constructor(parent: Container, position: PointData, text: string = 'E') {
		this.graphics = new Graphics();
		const width = text == 'SPACE' ? 80 : 20;
		const height = 20;
		this.graphics.rect(-width / 2, -height / 2, width, height);
		this.graphics.fill({color: 0xD5E1C0});
		this.graphics.stroke({color: 0x474D3F, width: 3});
		this.keyText = new Text({
			text: text,
			anchor: {x: 0.5, y: 0.5},
			style: {
				fontSize: 16,
				fontWeight: 'bold',
				fill: 0x000000,
			}
		});
		this.description = new Text({
			text: 'Hold',
			anchor: {x: 1, y: 0.5},
			style: {
				fontSize: 16,
				fontWeight: 'bold',
				fill: 0xFFFFFF,
			},
			x: -16,
			visible: false,
		});
		this.container.addChild(this.graphics);
		this.container.addChild(this.keyText);
		this.container.addChild(this.description);
		this.container.position = position;
		this.container.visible = false;
		parent.addChild(this.container);
	}

	public tick(deltaMS: number) {
		this.elapsed += deltaMS;
		this.graphics.scale = 1 + Math.sin(this.elapsed / 200) / 10;
		this.keyText.scale = 1 + Math.sin(this.elapsed / 200) / 10;
	}

	// region ITransform

	public get x(): number {
		return this.container.x;
	}

	public set x(value: number) {
		this.container.x = value;
	}

	public get y(): number {
		return this.container.y;
	}

	public set y(value: number) {
		this.container.y = value;
	}

	public get w(): number {
		return this.container.width;
	}

	public get h(): number {
		return this.container.height;
	}

	// endregion
}
